const getId = () => Math.random().toString(16).slice(2);

const recommends = [
  {
    title: 'Os Incríveis 2',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/3CCE3C67240CCED70FD7DB26B3EB62B762ABDD3835CCAACEDC670FC0EB907C3F/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Os Incríveis',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/90C609B13AA6AD7D8387C79AB0F2A0076C29A155624140E34774964E27E73E3D/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Luca',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/AD254DF69DADAC2F183D8289DCD56AE705304234938DC633291D11B4E1341A5E/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Raya e o Último Dragão',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/38DB345E61A9B0528EFE4761E16557F5E831C301364DFFD5B979DE1BDCD2EBC0/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Gnomeu e Julieta',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/0CE0BF9E3B13DEC6254FCF5209535D0FEE994648827F240ECE519858324C12C4/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Ferdinand',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/28B77D3C9D32153169CF10C201AEC6694CA89D47BDB5596E2EC8044D90F759A3/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Irmão Urso',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/4079B185CED198A39157827DD49297EA086A00DE2D259B77935ACAA984EEA3E6/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Red - Crescer é uma Fera',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/1F9CEB2CEA3496D12135F968122F7C317624E3EF66894F2CBF3872A61ADCD32B/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Soul',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/8BD61C065CFBE1D67E0FEF02D94BBB42A1971B8F04BB65ED3CEB3663BBFB9756/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Ron Bugado',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/E61108A19602C30C1353399B1674B1A79CF345D7045D223CC7BDF193EED38938/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Dois Irmãos: Uma Jornada Fantástica',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/DDCF12B61A920DD583124768459E54DD35D6A427DFB0256702CD9712D66957CB/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Valente',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/60240F111CD087B18B918D7C6724265F76554F9AF8E74D089E5E6D1773142199/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'O Rei Leão',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/3440D0A03E82FBB375499DBD5E09C9388208AEC5C35E5BA7BD460AB22ED08DE7/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
];

export default recommends;
